import axios from 'axios';
import {
    ElMessage
} from 'element-plus'
import router from '../router';

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // baseURL: 'http://172.16.9.53:7585/',
    // baseURL: 'http://172.16.32.37:8000/',
    // baseURL: 'http://116.62.156.224:7686',
    // baseURL: 'https://app.china-ccw.com:53443/jcy8000',
    baseURL : "https://plat.suanju.net/api",
    timeout: 30000
});

// 请求拦截
service.interceptors.request.use(
    config => {
        if (config.url !== 'system/account/getToken' && config.url !== 'system/account/getLoginQrCode' && config.url !== 'system/account/getCode'  && config.url !== 'system/account/checkQrCode') { // 登录接口 不需要 token
            try {
                const userInfo = localStorage.getItem("userInfo");
                if (userInfo) {
                    const userInfoObj = JSON.parse(userInfo);
                    if (userInfoObj && userInfoObj.token) {
                        config.headers = {
                            'token': userInfoObj.token,
                            'version': "1.0.0",
                            'source': '1',
                        }
                    } else {
                        router.push('/login');
                        config.headers = {
                            'version': "1.0.0",
                            'source': '1'
                        }
                    }
                } else {
                    router.push('/login');
                    config.headers = {
                        'version': "1.0.0",
                        'source': '1'
                    }
                }
            } catch (e) {
                console.error('解析用户信息失败:', e);
                router.push('/login');
                config.headers = {
                    'version': "1.0.0",
                    'source': '1'
                }
            }
        } else if (!localStorage.getItem('userInfo')) { //没有token
            router.push('/login')
            config.headers = {
                'version': "1.0.0",
                'source': '1'
            }
        } else {
            config.headers = {
                'version': "1.0.0",
                'source': '1'
            }
        }
        return config;
    },
    error => {
        console.error('请求拦截器错误:', error);
        return Promise.reject(error);
    }
);


// 响应拦截
service.interceptors.response.use(
    // 0 成功
    // 2 token 过期
    // 3 无权限
    response => {
        // 文件下载类请求（responseType: 'blob'）直接放行，不走业务码解析
        if (response.config && response.config.responseType === 'blob') {
            return Promise.resolve(response);
        }
        if (response.data.code === 0) {
            return Promise.resolve(response.data);
        } else if (response.data.code == 2) {
            ElMessage({
                showClose: true,
                message: response.data.msg,
                type: 'error'
            });
            window.location.href = '/Login'
            localStorage.removeItem("userInfo")
            return Promise.reject(response.data);
        } else if (response.data.code == 3) {
            ElMessage({
                showClose: true,
                message: response.data.msg,
                type: 'error'
            });
            return Promise.reject(response.data);
            // window.location.href = '/403'
        } else {
            // 处理其他错误情况（如登录失败等）
            let errorMessage = '操作失败';

            // 尝试从响应中获取错误信息
            if (response.data && response.data.msg) {
                errorMessage = response.data.msg;
            } else if (response.data && typeof response.data === 'string') {
                errorMessage = response.data;
            } else if (response.data && response.data.message) {
                errorMessage = response.data.message;
            } else if (response.data && response.data.code) {
                // 根据错误码提供默认提示
                errorMessage = `操作失败 (错误码: ${response.data.code})`;
            }

            ElMessage({
                showClose: true,
                message: errorMessage,
                type: 'error'
            });

            // 确保返回的 reject 对象包含 msg 字段，便于后续处理
            return Promise.reject({
                code: response.data.code || -1,
                msg: errorMessage,
                data: response.data
            });
        }
    },
    error => {
        console.error('响应错误:', error);

        // 处理网络错误
        if (error.response) {
            // 服务器返回了错误响应
            const { status, data } = error.response;
            let errorMessage = '请求失败';

            if (data && data.msg) {
                errorMessage = data.msg;
            } else if (data && typeof data === 'string') {
                errorMessage = data;
            } else if (status === 404) {
                errorMessage = '请求的资源不存在';
            } else if (status === 500) {
                errorMessage = '服务器内部错误';
            } else if (status === 403) {
                errorMessage = '没有权限访问';
            } else if (status === 401) {
                errorMessage = '未授权，请重新登录';
                localStorage.removeItem("userInfo");
                router.push('/login');
            } else {
                errorMessage = `请求失败 (${status})`;
            }

            ElMessage({
                showClose: true,
                message: errorMessage,
                type: 'error'
            });

            return Promise.reject({
                code: status,
                msg: errorMessage,
                data: data
            });
        } else if (error.request) {
            // 请求已发出但没有收到响应
            ElMessage({
                showClose: true,
                message: '网络连接失败，请检查网络设置',
                type: 'error'
            });

            return Promise.reject({
                code: -1,
                msg: '网络连接失败',
                error: error.message || 'Network Error'
            });
        } else {
            // 其他错误
            const errorMessage = error.message || '请求配置错误';
            ElMessage({
                showClose: true,
                message: errorMessage,
                type: 'error'
            });

            return Promise.reject({
                code: -2,
                msg: errorMessage,
                error: error
            });
        }
    }
);

export default service;
